function add_classes(el, classes) {
  classes.split(' ').forEach(c => el.classList.add(c));
}
function remove_classes(el, classes) {
  classes.split(' ').forEach(c => el.classList.remove(c));
}

export {
	add_classes,
	remove_classes,
};
